import {
    DatePipe,
    NgForOf,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    SlicePipe,
} from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
    ReactiveFormsModule,
    ValidationErrors,
    ValidatorFn,
} from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import {
    MatDateRangeInput,
    MatDateRangePicker,
    MatDatepickerModule,
    MatDatepickerToggle,
} from '@angular/material/datepicker';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslocoPipe } from '@ngneat/transloco';
import { ProductionStatusArrayPipe } from '../../pipes/production-status-array.pipe';
import { ProductionStatusPipe } from '../../pipes/production-status.pipe';
import { FilterField } from './filter.types';

const dateRangeValidator: ValidatorFn = (
    group: AbstractControl
): ValidationErrors | null => {
    const start = group.get('start')?.value;
    const end = group.get('end')?.value;
    if (start && end && new Date(start) > new Date(end)) {
        return { dateRangeInvalid: true };
    }
    return null;
};

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    standalone: true,
    imports: [
        MatButton,
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatLabel,
        MatIcon,
        NgSwitch,
        NgSwitchCase,
        NgForOf,
        MatInputModule,
        MatSelect,
        MatOption,
        MatCheckbox,
        NgSwitchDefault,
        MatIconButton,
        MatDatepickerModule,
        DatePipe,
        TranslocoPipe,
        MatError,
        NgIf,
        NgSelectModule,
        SlicePipe,
        ProductionStatusPipe,
        ProductionStatusArrayPipe,
        MatDateRangeInput,
        MatDateRangePicker,
        MatDatepickerToggle,
    ],
})
export class FilterComponent implements OnInit {
    @Input() initialFilters: Record<string, any> = {};
    @Input() fields: FilterField[] = [];
    @Input() showSearch = false;
    @Output() filterSubmit = new EventEmitter<any>();

    filterForm: FormGroup;
    searchControl: FormControl = new FormControl('');

    constructor(private fb: FormBuilder) {}

    ngOnInit() {
        this.filterForm = this.fb.group({});

        this.fields.forEach((field) => {
            if (field.type === 'date-range') {
                // build a sub-group with its own validators + our date-range check
                this.filterForm.addControl(
                    field.name,
                    this.fb.group(
                        {
                            start: ['', field.validatorsFrom || []],
                            end: ['', field.validatorsTo || []],
                        },
                        { validators: dateRangeValidator }
                    )
                );
            } else {
                this.filterForm.addControl(
                    field.name,
                    this.fb.control('', field.validators)
                );
            }
        });

        this.filterForm.valueChanges.subscribe(
            val => {
                console.log("filter val:" , val);
                console.log("form: ", this.filterForm);
            }
        )

        if (this.initialFilters) {
            this.filterForm.patchValue(this.initialFilters);
        }
    }

    filteredFields(): FilterField[] {
        const searchTerm = this.searchControl.value.toLowerCase();
        if (!searchTerm) {
            return this.fields;
        }
        return this.fields.filter((field) =>
            field.label.toLowerCase().includes(searchTerm)
        );
    }

    onApplyFilters() {
        // Emit or handle the filter values
        this.filterSubmit.emit(this.filterForm.getRawValue());
    }

    onResetFilters() {
        this.filterForm.reset();
        this.filterSubmit.emit(null);
    }
}
